import { useCallback, useState } from 'react';

export function useCreditorDetailModals({ app, companyId }) {
  const [bankModal, setBankModal] = useState({
    open: false,
    loading: false,
    error: null,
    creditorName: '',
    data: null,
  });
  const [paymentsModal, setPaymentsModal] = useState({
    open: false,
    loading: false,
    error: null,
    creditorName: '',
    payload: null,
  });
  const [addressModal, setAddressModal] = useState({
    open: false,
    loading: false,
    error: null,
    creditorName: '',
    address: null,
    synced_at: null,
  });
  const [contactModal, setContactModal] = useState({
    open: false,
    loading: false,
    error: null,
    creditorName: '',
    phones: [],
    contacts: [],
    synced_at: null,
  });

  const closeBankModal = useCallback(() => {
    setBankModal({ open: false, loading: false, error: null, creditorName: '', data: null });
  }, []);
  const closePaymentsModal = useCallback(() => {
    setPaymentsModal({ open: false, loading: false, error: null, creditorName: '', payload: null });
  }, []);
  const closeAddressModal = useCallback(() => {
    setAddressModal({ open: false, loading: false, error: null, creditorName: '', address: null, synced_at: null });
  }, []);
  const closeContactModal = useCallback(() => {
    setContactModal({ open: false, loading: false, error: null, creditorName: '', phones: [], contacts: [], synced_at: null });
  }, []);

  const openBankModal = useCallback(
    async (row) => {
      if (!companyId) return;
      setBankModal({
        open: true,
        loading: true,
        error: null,
        creditorName: row.name,
        data: null,
      });
      try {
        const data = await app.fetchCreditorBankInformations(companyId, row.id);
        setBankModal((m) => ({ ...m, loading: false, data }));
      } catch (e) {
        setBankModal((m) => ({
          ...m,
          loading: false,
          error: e.message || 'Não foi possível carregar os dados bancários.',
          data: null,
        }));
      }
    },
    [app, companyId],
  );

  const openPaymentsModal = useCallback(
    async (row) => {
      if (!companyId) return;
      setPaymentsModal({
        open: true,
        loading: true,
        error: null,
        creditorName: row.name,
        payload: null,
      });
      try {
        const paymentsPayload = await app.fetchCreditorPayments(companyId, row.id, { per_page: 100 });
        setPaymentsModal((m) => ({ ...m, loading: false, payload: paymentsPayload }));
      } catch (e) {
        setPaymentsModal((m) => ({
          ...m,
          loading: false,
          error: e.message || 'Não foi possível carregar os pagamentos do credor.',
          payload: null,
        }));
      }
    },
    [app, companyId],
  );

  const openAddressModal = useCallback(
    async (row) => {
      if (!companyId) return;
      setAddressModal({
        open: true,
        loading: true,
        error: null,
        creditorName: row.name,
        address: null,
        synced_at: null,
      });
      try {
        const data = await app.fetchCreditorAddressDetail(companyId, row.id);
        setAddressModal((m) => ({
          ...m,
          loading: false,
          address: data?.address ?? null,
          synced_at: data?.synced_at ?? null,
        }));
      } catch (e) {
        setAddressModal((m) => ({
          ...m,
          loading: false,
          error: e.message || 'Não foi possível carregar o endereço.',
          address: null,
          synced_at: null,
        }));
      }
    },
    [app, companyId],
  );

  const openContactModal = useCallback(
    async (row) => {
      if (!companyId) return;
      setContactModal({
        open: true,
        loading: true,
        error: null,
        creditorName: row.name,
        phones: [],
        contacts: [],
        synced_at: null,
      });
      try {
        const data = await app.fetchCreditorContactDetail(companyId, row.id);
        setContactModal((m) => ({
          ...m,
          loading: false,
          phones: Array.isArray(data?.phones) ? data.phones : [],
          contacts: Array.isArray(data?.contacts) ? data.contacts : [],
          synced_at: data?.synced_at ?? null,
        }));
      } catch (e) {
        setContactModal((m) => ({
          ...m,
          loading: false,
          error: e.message || 'Não foi possível carregar os contactos.',
          phones: [],
          contacts: [],
          synced_at: null,
        }));
      }
    },
    [app, companyId],
  );

  return {
    bankModal,
    paymentsModal,
    addressModal,
    contactModal,
    closeBankModal,
    closePaymentsModal,
    closeAddressModal,
    closeContactModal,
    openBankModal,
    openPaymentsModal,
    openAddressModal,
    openContactModal,
  };
}
